import React, { Component } from 'react'
import { connect } from 'react-redux'

class RequireChecklist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      layoutName: '',
      listTab: {},
      isPr: false,
    };
  }

  componentDidMount() {
    const { listTab, layoutName, isPr } = this.props;
    this.setState({ listTab, layoutName, isPr });
  }

  componentWillUnmount() {
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      listTab: nextProps.listTab,
      layoutName: nextProps.layoutName,
      isPr: nextProps.isPr
    });
  }

  render() {
    let { listTab, layoutName, isPr } = this.state;
    const arrayCheckListTabRequirement = Object.values(listTab).filter(tab => !tab.isSEOCheck)
    const arrayCheckListTabSEO = Object.values(listTab).filter(tab => tab.isSEOCheck)

    return (
      <div className="card" style={{ backgroundColor: "rgb(255, 255, 230)", width: "250px" }}>
        <div className="card-header col-12 py-2">
          <h4 className="card-title">Yêu cầu khi soạn bài</h4>
          {layoutName === 'layout-pc-2' &&
            <div className="card-tools">
              <button type="button" className="btn btn-tool" data-card-widget="collapse">
                <i className="fas fa-minus"></i>
              </button>
            </div>
          }
        </div>
        <div className="card-body col-12 py-2">
          <ul className="todo-list ui-sortable" data-widget="todo-list">
            {arrayCheckListTabRequirement && arrayCheckListTabRequirement.map((tab, idx) => {
              if (tab.tabName === 'content_m') {
                return <React.Fragment key={idx}></React.Fragment>
              }
              if (tab.tabName === 'pr' && !isPr) {
                return <React.Fragment key={idx}></React.Fragment>
              }

              return <li key={idx} className={(tab.error ? ` ${((tab.classname && tab.classname.length > 2) ? tab.classname[2] : ``)}` : ` checked ${((tab.classname && tab.classname.length > 2) ? tab.classname[2] : ``)}`)} style={{ backgroundColor: "unset", border: "unset", padding: "0" }}>
                <div className="icheck-primary d-inline no-background">
                  <input type="checkbox" checked={tab.error ? '' : 'checked'} name="todo1" id={"todoCheck" + idx} disabled="disabled" />
                  <label htmlFor={"todoCheck" + idx}></label>
                </div>
                <span className="text">{tab.requireText}</span>
              </li>
            })}
          </ul>
        </div>
        <div className="card-header col-12 py-2">
          <h4 className="card-title">Yêu cầu về SEO</h4>
          {layoutName === 'layout-pc-2' &&
            <div className="card-tools">
              <button type="button" className="btn btn-tool" data-card-widget="collapse">
                <i className="fas fa-minus"></i>
              </button>
            </div>
          }
        </div>
        <div className="card-body col-12 py-2">
          <ul className="todo-list ui-sortable" data-widget="todo-list">
            {arrayCheckListTabSEO && arrayCheckListTabSEO.map((tab, idx) => {
              if (tab.tabName === 'content_m') {
                return <React.Fragment key={idx}></React.Fragment>
              }
              if (tab.tabName === 'pr' && !isPr) {
                return <React.Fragment key={idx}></React.Fragment>
              }

              return <li key={idx} className={(tab.error ? ` ${((tab.classname && tab.classname.length > 2) ? tab.classname[2] : ``)}` : ` checked ${((tab.classname && tab.classname.length > 2) ? tab.classname[2] : ``)}`)} style={{ backgroundColor: "unset", border: "unset", padding: "0" }}>
                <div className="icheck-primary d-inline no-background">
                  <input type="checkbox" checked={tab.error ? '' : 'checked'} name="todo1" id={"todoCheckSEO" + idx} disabled="disabled" />
                  <label htmlFor={"todoCheckSEO" + idx}></label>
                </div>
                <span className="text">{tab.requireText}</span>
              </li>
            })}
          </ul>
        </div>
      </div>
    )
  }

};


export default connect(store => {
  return {
    post: store.post,
    config: store.config
  };
}, dispatch => {
  return {

  }
})(RequireChecklist)
